<template>
  <div v-if="isLoading" class="flex justify-center items-center h-40">
    <VueSpinnerIos size="40px" />
  </div>
  <div v-else class="h-[28rem] overflow-y-auto">
    <!-- Search Input -->
    <input
      type="text"
      v-model="query"
      class="input w-full h-10"
      placeholder="جستجو کنید..."
    />
    <!-- Filtered Tags -->
    <div class="flex flex-wrap gap-2 mt-4">
      <button
        v-for="tag in filteredTags"
        :key="tag?.id"
        :class="[
          'rounded-xl  text-xs px-4 h-5 transition-colors',
          tag.isSelected
            ? 'bg-teal-200 text-teal-500 hover:bg-teal-300'
            : 'bg-[#ECF2FF] text-blue-primary hover:bg-[#D6E4FF]',
        ]"
        @click="handleTagClick(tag)"
      >
        {{ tag.name }}
      </button>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from "vue";
import { VueSpinnerIos } from "vue3-spinners";
import { useStore } from "vuex";

const store = useStore();

const tags = computed(() => store.state.leadsSlice.tags);
const isLoading = ref(false);
const query = ref("");

// Computed property to filter tags based on the search query
const filteredTags = computed(() =>
  tags.value.filter((tag) =>
    tag.name.toLowerCase().includes(query.value.toLowerCase())
  )
);

onMounted(async () => {
  isLoading.value = true;
  if (tags.value.length === 0) {
    await store.dispatch("leadsSlice/loadTagsArray");
  }
  isLoading.value = false;
});

const handleTagClick = (tag) => {
  store.commit("leadsSlice/toggleTagIsSelected", tag.id);
  store.commit("leadsSlice/toggleSelectedTag", tag);
};
</script>
